var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#35A854",
  d: "M63.926 20.466c.058 10.417-.029 20.863 0 31.28 0 2.21-1.57 4.16-3.637 4.16H49.35V31.203l14.606-10.766z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#4284F3",
  d: "M14.52 31.232v24.704H3.578c-1.833 0-3.55-1.63-3.55-3.55V20.408l14.52 10.853z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C4221F",
  d: "M14.52 12.436v18.796L0 20.38v-6.198c0-.785.32-2.182.815-2.851C2.502 9.03 5.15 7.576 7.944 8.158c2.124.437 4.771 2.94 6.546 4.249z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#E94335",
  d: "M49.32 12.436V31.32L31.86 44.239l-17.37-12.92V12.437c5.819 4.306 11.61 8.67 17.429 12.977 5.848-4.277 11.58-8.671 17.37-12.978z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FABB05",
  d: "M63.926 20.466 49.32 31.232V12.436c3.433-2.561 6.78-6.198 11.377-3.463 4.131 2.444 3.23 6.925 3.2 11.522z"
})));
export default SvgGmail;